import {useQuery} from "@tanstack/react-query"
import moment from "moment"
import {attendanceService} from "services"

type UseTotalScheduleHoursToLdaParams = {
    studentProfileId?: number
    startDate?: string
    enabled?: boolean
}

export const useTotalScheduleHoursToLda = ({
    studentProfileId,
    startDate,
    enabled = true
}: UseTotalScheduleHoursToLdaParams) => {
    return useQuery(
        ["total-schedule-hours-to-lda", studentProfileId, startDate],
        async () => {
            const fromDate = startDate
                ? moment(startDate).subtract(1, "year").format("YYYY-MM-DD")
                : moment().subtract(5, "years").format("YYYY-MM-DD")
            const toDate = moment().add(1, "year").format("YYYY-MM-DD")

            const response = await attendanceService.getDailyAttendanceSummaryCalendarReport({
                studentProfileId,
                fromDate,
                toDate
            })
            return response?.data?.totalScheduleHoursToLda
        },
        {
            enabled: enabled && !!studentProfileId,
            staleTime: 60 * 1000
        }
    )
}
